import Component from "vue-class-component";
import Vue from "vue";
import { namespace } from "vuex-class";
import { StateSystemSettings } from "@/store/types";
import { ACTION_TYPES } from "@/lib/const";
import { InputSystemSettings, SystemSettings } from "@teacherskaya/api-provider/dist/api/SystemSettingsProvider";

export const storePath = "settings";
const Store = namespace(storePath);

@Component({ name: "WithSystemSettings" })
export default class WithSystemSettings extends Vue {
  @Store.State(state => state)
  public readonly systemSettingsState!: StateSystemSettings;

  @Store.Action(ACTION_TYPES.GET_DATA)
  public systemSettingsGet!: () => Promise<SystemSettings>;

  @Store.Action(ACTION_TYPES.SET_DATA)
  public systemSettingsUpdate!: (payload: { data: InputSystemSettings }) => Promise<SystemSettings>;
}
